import React from 'react';

import { Android, Apple, Computer, Warning } from '@mui/icons-material';
import { Box } from '@mui/material';

type PromoRequestDeviceTypeProps = {
  deviceType?: string;
  requestSource?: string;
};

function PromoRequestDeviceType({ deviceType, requestSource }: PromoRequestDeviceTypeProps) {
  if (!deviceType) {
    return (
      <Box title="Unknown request source">
        <Warning />
      </Box>
    );
  }

  switch (deviceType) {
    case 'android':
      return (
        <Box title={`Request via android app [${requestSource}]`}>
          <Android />
        </Box>
      );
    case 'ios':
      return (
        <Box title={`Request via ios [${requestSource}]`}>
          <Apple />
        </Box>
      );
    case 'web':
      return (
        <Box title={`Request made via website [${requestSource}]`}>
          <Computer />
        </Box>
      );
    default:
      return (
        <Box title={`Request made via unknown request source: "${deviceType}" [${requestSource}]`}>
          <Warning />
        </Box>
      );
  }
}

export { PromoRequestDeviceType };
